<template>
  <customize-form :schema="schema" ref="form" />
</template>

<script>
import { getSelectList } from '@/api'
import { getCustomerInfo } from 'views/customer-mangement/detail/info/basic-profile/api'
export default {
  data() {
    return {
      schema: [
        {
          label: 'Product Name',
          type: 'select',
          key: 'productName',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          selectList: [
            {
              id: 1,
              name: 'Data Blocks',
            },
          ],
          value: 1,
        },
        {
          type: 'input',
          label: 'Duns Number',
          key: 'dunsNumber',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          type: 'select',
          label: 'Country Code',
          key: 'country',
          selectList: [],
        },
        {
          type: 'select',
          label: 'Trade up Indicator',
          key: 'tradeUpIndicator',
          selectList: [
            {
              id: 1,
              name: 'Y',
            },
            {
              id: 2,
              name: 'N',
            },
          ],
        },
        {
          type: 'select',
          label: 'Reason Code',
          key: 'reasonCode',
          value: 6332,
          selectList: [
            {
              id: 6332,
              name: 'Credit Decision',
            },
            {
              id: 6333,
              name: 'Assessment of credit solvency for intended business connection',
            },
            {
              id: 6334,
              name: 'Assessment of credit solvency for ongoing business connection',
            },
            {
              id: 6335,
              name: 'Debt Collection',
            },
            {
              id: 6336,
              name: 'Commercial Credit Insurance',
            },
            {
              id: 6337,
              name: 'Insurance Contract',
            },
            {
              id: 6338,
              name: 'Leasing Agreement',
            },
            {
              id: 6339,
              name: 'Rental Agreement',
            },
          ],
        },
      ],
    }
  },
  created() {
    this._getCountryList()
    this._initFormDefaultValue()
    this._getCustomerInfo()
  },
  methods: {
    async _getCustomerInfo() {
      try {
        const { base } = await getCustomerInfo(this.$route.params.customerId)
        this.schema.forEach((item, index) => {
          if (item.key === 'dunsNumber') {
            this.schema.splice(index, 1, { ...item, value: base.dunsNo })
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    _initFormDefaultValue() {
      this.schema.forEach((item, index) => {
        if (item.key === 'dunsNumber') {
          this.schema.splice(index, 1, {
            ...item,
            value: this.$route.query.dunsNumber,
          })
        }
      })
    },
    async validate() {
      const valid = await this.$refs.form.validateFields()
      if (valid) {
        const result = this.$refs.form.getFormData()
        if (result.country) {
          result.country = this.countryList.filter(
            item => item.id === result.country,
          )[0].mark
        }
        return result
      }
    },
    async _getCountryList() {
      try {
        const result = await getSelectList('Country')
        this.schema[2].selectList = result
        this.countryList = result
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
